import styled from 'styled-components';
import { Typography } from '~/ui/components';
import { themeToggleColor } from '~/common/utils/theme';

export const Container = styled.div<{ bgColor: string }>`
  background: ${({ theme, bgColor }) => bgColor || themeToggleColor(theme, 'background.primary')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 54px 24px;
  text-align: center;
  gap: 15px;
  width: 100%;

  img {
    width: 300px;
  }
`;

export const Title = styled(Typography).attrs(({ theme }) => ({
  type: 'headingSmall',
  color: theme.colors.element.primary,
}))``;

export const Message = styled(Typography).attrs(({ theme }) => ({
  type: 'paragraphLarge',
  color: theme.colors.element.primary,
  weight: 500,
  width: 553,
}))``;
